import "../App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ScrollToTop from "../components/ScrollToTop";
import Home from "./Home";
import Page from "../components/Page";
import Header from "../components/Header";
import Specials from "./Specials";
import Feedback from "./Contact";
import Featured from "./Featured";
import Footer from "../components/Footer";
import { Analytics } from "@vercel/analytics/react";
import { useEffect, useState } from "react";

function App() {
  const [isDarkMode, setIsDarkMode] = useState(
    () => window.localStorage.getItem("theme") === "dark",
  );

  useEffect(() => {
    document.documentElement.classList.toggle("dark-mode", isDarkMode);
  }, [isDarkMode]);

  useEffect(() => {
    const handleThemePreferenceChange = (event) => {
      setIsDarkMode(event.detail.isDarkMode);
    };

    window.addEventListener("theme-preference-change", handleThemePreferenceChange);
    return () => {
      window.removeEventListener("theme-preference-change", handleThemePreferenceChange);
    };
  }, []);

  const chooseTheme = (darkMode) => {
    setIsDarkMode(darkMode);
    window.localStorage.setItem("theme", darkMode ? "dark" : "light");
  };

  return (
    <Router>
      <ScrollToTop />
      <div className={`App h-max flex flex-col ${isDarkMode ? "theme-dark" : ""}`}>
        <Analytics />
        <Header isDarkMode={isDarkMode} onToggleTheme={() => chooseTheme(!isDarkMode)} />
        <div className="blank-space nav:h-[17vh] h-[12vh]"></div>
        <div className="main-content flex-grow flex flex-col">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/happyhours" element={<Page page={"happyhours"} />} />
            <Route path="/map" element={<Page page="map" />} />
            <Route path="/events" element={<Page page={"events"} />} />
            <Route path="/featured" element={<Featured />} />
            <Route path="/contact" element={<Feedback />} />
            {/* SPECIALS */}
            <Route path="/specials" element={<Specials />} />
            <Route
              path="/specials/wine"
              element={<Page page={"specials"} special={"wine"} />}
            />
            <Route
              path="/specials/margarita"
              element={<Page page={"specials"} special={"margarita"} />}
            />
            <Route
              path="/specials/martini"
              element={<Page page={"specials"} special={"martini"} />}
            />
            {/* GAME DAY SPECIALS */}
            <Route
              path="/game-day-specials"
              element={<Page page={"gameDaySpecials"} />}
            />
            {/* DAY LINKS */}
            <Route
              path="/sunday-happy-hours"
              element={<Page page={"happyhours"} day={"Sunday"} />}
            />
            <Route
              path="/monday-happy-hours"
              element={<Page page={"happyhours"} day={"Monday"} />}
            />
            <Route
              path="/tuesday-happy-hours"
              element={<Page page={"happyhours"} day={"Tuesday"} />}
            />
            <Route
              path="/wednesday-happy-hours"
              element={<Page page={"happyhours"} day={"Wednesday"} />}
            />
            <Route
              path="/thursday-happy-hours"
              element={<Page page={"happyhours"} day={"Thursday"} />}
            />
            <Route
              path="/friday-happy-hours"
              element={<Page page={"happyhours"} day={"Friday"} />}
            />
            <Route
              path="/saturday-happy-hours"
              element={<Page page={"happyhours"} day={"Saturday"} />}
            />
            {/* TOWN LINKS */}
            <Route
              path="red-bank-happy-hours"
              element={<Page page={"happyhours"} town={"Red Bank"} />}
            />
            <Route
              path="/long-branch-happy-hours"
              element={<Page page={"happyhours"} town={"Long Branch"} />}
            />
            <Route
              path="/asbury-park-happy-hours"
              element={<Page page={"happyhours"} town={"Asbury Park"} />}
            />
            {/* <Route
              path="/ocean-grove-happy-hours"
              element={<Page page={"happyhours"} town={"Ocean Grove"} />}
            /> */}
            <Route
              path="/bradley-beach-happy-hours"
              element={<Page page={"happyhours"} town={"Bradley Beach"} />}
            />
            <Route
              path="/avon-by-the-sea-happy-hours"
              element={<Page page={"happyhours"} town={"Avon-by-the-sea"} />}
            />
            <Route
              path="/belmar-happy-hours"
              element={<Page page={"happyhours"} town={"Belmar"} />}
            />
            <Route
              path="/spring-lake-happy-hours"
              element={<Page page={"happyhours"} town={"Spring Lake"} />}
            />
            <Route
              path="/manasquan-happy-hours"
              element={<Page page={"happyhours"} town={"Manasquan"} />}
            />
            <Route
              path="/sea-girt-happy-hours"
              element={<Page page={"happyhours"} town={"Sea Girt"} />}
            />
            <Route
              path="/brielle-happy-hours"
              element={<Page page={"happyhours"} town={"Brielle"} />}
            />
            <Route
              path="/point-pleasant-happy-hours"
              element={<Page page={"happyhours"} town={"Point Pleasant"} />}
            />
          </Routes>
        </div>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
